import { render, staticRenderFns } from "./CompanionDailyStrategy.vue?vue&type=template&id=efd66b02&scoped=true&lang=pug&"
import script from "./CompanionDailyStrategy.vue?vue&type=script&lang=js&"
export * from "./CompanionDailyStrategy.vue?vue&type=script&lang=js&"
import style0 from "./CompanionDailyStrategy.vue?vue&type=style&index=0&id=efd66b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd66b02",
  null
  
)

export default component.exports